import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100/60 border-t border-secondary-200/50">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-flower-line text-primary-500 text-xl"></i>
              </div>
              <span className="font-heading text-lg text-foreground-900">樱花动漫</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              樱花动漫网 - 免费动漫在线观看平台，每日更新热门动漫资源，涵盖各类动漫类型，让追番更简单。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-800 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">分类浏览</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-800 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">热血动漫</Link>
              <Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">恋爱动漫</Link>
              <Link to="/category/qihuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">奇幻动漫</Link>
              <Link to="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">搞笑动漫</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm text-foreground-800 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>邮箱：contact@sakura-anime.com</span>
              <span>QQ群：1234567890</span>
              <span>地址：广州市天河区动漫产业园</span>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-secondary-200/50 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-xs text-foreground-500">
            &copy; 2024 樱花动漫网 Sakura-Anime. All Rights Reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站所有资源均来自网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}